export const consentKey = 'osm.allowed';

export function isAllowed() {
    return localStorage.getItem(consentKey) === 'true';
}

/**
 * @param {boolean} status
 */
export function updateConsent(status) {
    localStorage.setItem(consentKey, status.toString());
}
